<template>
  <div class="prescriberRegistrationStep2">
    <!-- step 2 -->
    <div class="row grid-align-center">
      <div class="col-md-12 prescriberRegistrationStep2__stepTitle">{{ prescriberRegistrationTexts.Step2.PageTitle }}</div>
      <div class="col-md-6 prescriberRegistrationStep2__block">
        <div class="prescriberRegistrationStep2__block__header">Uw (zakelijke) gegevens</div>
        <p class="prescriberRegistrationStep2__stepSubtitle">Voor een correcte gegevensverwerking en verificatie van uw identiteit hebben wij uw correcte gegevens nodig. Indien uw gegevens niet juist zijn kunnen wij uw account niet aanmaken.</p>
        <div class="prescriberRegistrationStep2__block__content">
          <div class="row grid-padding prescriberRegistrationStep2__block__content__section">
            <div class="col-xs-4 prescriberRegistrationStep2__block__content__section__gender">
              <span class="form-group__radio">
                <input id="prescriberGenderMale" :checked="prescriberRegistrationDetails.titleId === 1" @change="checkRadioAnswer(1)" name="gender" type="radio" value="De heer"/>
                <label for="prescriberGenderMale"><span><span></span></span>De heer</label>
              </span>
              <span class="form-group__radio">
                <input id="prescriberGenderFemale" :checked="prescriberRegistrationDetails.titleId === 2" @change="checkRadioAnswer(2)" name="gender" type="radio" value="Mevrouw" />
                <label for="prescriberGenderFemale"><span><span></span></span>Mevrouw</label>
              </span>
            </div>
            <div class="col-xs-4">
              <v-input-group-simple
                v-model="formConfig.initials.model"
                :initvalue="formConfig.initials.model"
                @blur="validateField"
                :error="formConfig.initials.error"
                :errorMessage="formConfig.initials.errorMessage"
                :rule="formConfig.initials.rule"
                :inputid="formConfig.initials.ref"
                placeholder="Voorletters*">
              </v-input-group-simple>
            </div>
            <div class="col-xs-4">
              <v-input-group-simple
                v-model="formConfig.firstName.model"
                :initvalue="formConfig.firstName.model"
                @blur="validateField"
                :error="formConfig.firstName.error"
                :errorMessage="formConfig.firstName.errorMessage"
                :rule="formConfig.firstName.rule"
                :inputid="formConfig.firstName.ref"
                placeholder="Voornaam">
              </v-input-group-simple>
            </div>
          </div>
          <div class="row grid-padding prescriberRegistrationStep2__block__content__section">
            <div class="col-xs-4">
              <v-select-group
                v-model="formConfig.prePosition.model"
                selectid="prePositionCode"
                @change="select($event)"
                :overwriteValue="formConfig.prePosition.model"
                :initselected="formConfig.prePosition.model">
                <option value="">Selecteren Tussenvoegsel</option>
                      <option v-for="(item, index) in prePositionsData"
                      :key="index"
                      :data-index="index" 
                      :value="item.prePositionCode">
                      {{ item.prePosition }}
                    </option>
            </v-select-group>
            </div>
            <div class="col-xs-8">
              <v-input-group-simple
                v-model="formConfig.lastName.model"
                :initvalue="formConfig.lastName.model"
                @blur="validateField"
                :error="formConfig.lastName.error"
                :errorMessage="formConfig.lastName.errorMessage"
                :rule="formConfig.lastName.rule"
                :inputid="formConfig.lastName.ref"
                placeholder="Achternaam*">
              </v-input-group-simple>
            </div>
          </div>
          <div class="row grid-padding prescriberRegistrationStep2__block__content__section">
            <div class="col-xs-7">
              <v-input-group-simple
                v-model="formConfig.maidenName.model"
                :initvalue="formConfig.maidenName.model"
                @blur="validateField"
                :error="formConfig.maidenName.error"
                :errorMessage="formConfig.maidenName.errorMessage"
                :rule="formConfig.maidenName.rule"
                :inputid="formConfig.maidenName.ref"
                placeholder="Geboortenaam (vh meisjesnaam)">
              </v-input-group-simple>
            </div>
            <div class="col-xs-5">
              <v-input-group-simple
                v-model="formConfig.dateOfBirth.model"
                :initvalue="formConfig.dateOfBirth.model"
                @blur="validateField"
                :error="formConfig.dateOfBirth.error"
                :errorMessage="formConfig.dateOfBirth.errorMessage"
                :rule="formConfig.dateOfBirth.rule"
                :inputid="formConfig.dateOfBirth.ref"
                placeholder="Geboortedatum (dd-mm-jjjj)">
              </v-input-group-simple>
            </div>
          </div>
          <div class="row grid-padding prescriberRegistrationStep2__block__content__section">
            <div class="col-xs-6">
              <v-input-group-simple
                maxlength="10"
                v-model="formConfig.phoneNumber.model"
                :initvalue="formConfig.phoneNumber.model"
                @blur="validateField"
                :error="formConfig.phoneNumber.error"
                :errorMessage="formConfig.phoneNumber.errorMessage"
                :rule="formConfig.phoneNumber.rule"
                :inputid="formConfig.phoneNumber.ref"
                placeholder="Telefoonnummer (vast)">
              </v-input-group-simple>
            </div>
            <div class="col-xs-6">
              <v-input-group-simple
                maxlength="10"
                v-model="formConfig.mobileNumber.model"
                :initvalue="formConfig.mobileNumber.model"
                @blur="validateField"
                :error="formConfig.mobileNumber.error"
                :errorMessage="formConfig.mobileNumber.errorMessage"
                :rule="formConfig.mobileNumber.rule"
                :inputid="formConfig.mobileNumber.ref"
                placeholder="Telefoonnummer (mobiel)">
              </v-input-group-simple>
            </div>
          </div>
          <div class="row grid-padding prescriberRegistrationStep2__block__content__section">
            <div class="col-xs-6">
              <v-input-group-simple
                v-model="formConfig.email.model"
                :initvalue="formConfig.email.model"
                @blur="validateField"
                :error="formConfig.email.error"
                :errorMessage="formConfig.email.errorMessage"
                :rule="formConfig.email.rule"
                :inputid="formConfig.email.ref"
                placeholder="Uw persoonlijke, zakelijke e-mailadres*">
              </v-input-group-simple>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row  grid-align-center" v-if="showSuccessMessage" :class="{'flipInX animated': animated}">
      <div class="col-md-12 prescriberRegistrationStep2__successMessage">
        <v-check-circle-icon class="prescriberRegistrationStep2__successMessage__icon"></v-check-circle-icon>
        <span>Bovenstaande gegevens zijn gecontroleerd</span>
      </div>
    </div>
    <!-- Buttons section -->
    <div class="row prescriberRegistrationStep2__actions">
      <v-button lg hollow class="prescriberRegistrationStep2__actions__previous" v-if="getStepActionVisibilityStatus('prev')" @click.native.prevent="previousStep()">GA TERUG</v-button>
      <v-button lg cta v-if="getStepActionVisibilityStatus('next')" @click.native.prevent="nextStep()">VOLGENDE STAP</v-button>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import { Validator } from 'vee-validate'
import VCheckCircleIcon from 'icons/CheckCircle'

export default {
  name: 'v-registration-step2',
  components: {
    VCheckCircleIcon
  },
  data () {
    return {
      validator: new Validator(),
      formConfig: {},
      showSuccessMessage: false,
      animated: false,
      nextStepClicked: false
    }
  },
  computed: {
    ...mapGetters({
      prescriberRegistrationDetails: 'prescriberRegistration/getPrescriberRegistrationDetails',
      prescriberRegistrationSteps: 'prescriberRegistration/getPrescriberRegistrationSteps',
      prescriberRegistrationTexts: 'prescriberRegistration/getPrescriberRegistrationTexts',
      prePositionsData: 'prescriberRegistration/getPrePositionsRecords',
    })
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.formConfig = {
      initials: {
        model: this.prescriberRegistrationDetails.initials,
        ref: 'initials',
        label: 'Voorletters',
        attached: true,
        alias: 'Voorletters',
        rule: 'required',
        error: false
      },
      firstName: {
        model: this.prescriberRegistrationDetails.firstName,
        ref: 'firstName',
        label: 'Voornaam',
        attached: true,
        alias: 'Voornaam',
        rule: {
          required: false
        },
        error: false
      },
      prePosition: {
        model: this.prescriberRegistrationDetails.prePositionCode,
        ref: 'prePosition',
        label: 'Tussenvoegsel',
        attached: true,
        alias: 'Tussenvoegsel',
        rule: {
          required: false,
        },
        error: false
      },
      lastName: {
        model: this.prescriberRegistrationDetails.lastName,
        ref: 'lastName',
        label: 'Achternaam',
        attached: true,
        alias: 'Achternaam',
        rule: {
          required: true
        },
        error: false
      },
      maidenName: {
        model: this.prescriberRegistrationDetails.maidenName,
        ref: 'maidenName',
        label: 'Geboortenaam (vh meisjesnaam)',
        attached: true,
        alias: 'Geboortenaam',
        rule: {
          required: false
        },
        error: false
      },
      dateOfBirth: {
        model: this.prescriberRegistrationDetails.dateOfBirth,
        ref: 'dateOfBirth',
        label: 'Geboortedatum (dd-mm-jjjj)',
        attached: true,
        alias: 'Geboortedatum',
        rule: {
          required: false,
          date_format: 'DD-MM-YYYY'
        },
        error: false
      },
      phoneNumber: {
        model: this.prescriberRegistrationDetails.phoneNumber,
        ref: 'phoneNumber',
        label: 'Telefoonnummer (vast)',
        attached: true,
        alias: 'Telefoonnummer (vast)',
        rule: {
          required: false,
          numeric: true,
          length: 10
        },
        error: false
      },
      mobileNumber: {
        model: this.prescriberRegistrationDetails.mobileNumber,
        ref: 'mobileNumber',
        label: 'Telefoonnummer (mobiel)',
        attached: true,
        alias: 'Telefoonnummer (mobiel)',
        rule: {
          required: false,
          numeric: true,
          length: 10
        },
        error: false
      },
      email: {
        model: this.prescriberRegistrationDetails.email,
        ref: 'email',
        label: 'E-mailadres',
        attached: true,
        alias: 'E-mailadres',
        rule: 'required|email',
        error: false
      }
    }
    this.attachFieldsToValidator()
  },
  methods: {
    getStepActionVisibilityStatus (action) {
      if (action === 'prev') {
        return this.prescriberRegistrationSteps.findIndex(step => step.show) !== 0
      }
      return this.prescriberRegistrationSteps.findIndex(step => step.show) < 5
    },
    previousStep () {
      store.commit('prescriberRegistration/setPreviousStepActive')
    },
    nextStep () {
      if (!this.showSuccessMessage) {
        this.nextStepClicked = true
        this.validateAllFields()
        this.setErrors()
      }
    },
    attachFieldsToValidator () {
      for (let key in this.formConfig) {
        if (this.formConfig[key].attached) {
          this.validator.attach(
            this.formConfig[key].ref,
            this.formConfig[key].rule,
            { alias: this.formConfig[key].alias })
        }
      }
    },
    validateField (ref, model) {
      this.savePrescriberRegistrationDetails({
        key: ref,
        value: model
      })
      this.validator.validate(ref, model)
      this.nextStepClicked = false
      this.setErrors()
    },
    select (event) {
      if (event.target.value) {
        this.prescriberRegistrationDetails.prePosition = event.target.options[event.target.options.selectedIndex].text 
        this.prescriberRegistrationDetails.prePositionCode = event.target.value
        this.formConfig.prePosition.model = this.prescriberRegistrationDetails.prePositionCode
      } else {
        this.prescriberRegistrationDetails.prePosition = ''
        this.prescriberRegistrationDetails.prePositionCode =''
      }
    },
    validateAllFields (elements) {
      let validateObj = { }
      for (let key in this.formConfig) {
        if (typeof this.formConfig[key].ref !== 'undefined') {
          validateObj[this.formConfig[key].ref] = this.prescriberRegistrationDetails[key]
        }
      }
      this.validator.validateAll(validateObj).then(validated => {
        if (validated) {
          this.animated = true
          this.showSuccessMessage = true
          setTimeout(() => {
            this.animated = false
            store.commit('prescriberRegistration/setNextStepActive')
          }, 2000)
        } else {
        }
      }).catch(() => {
      })
    },
    setErrors () {
      // If the validator contains no errors
      if (this.validator.errors.items.length === 0) {
        for (let key in this.formConfig) {
          if (typeof this.formConfig[key].ref !== 'undefined') {
            this.formConfig[key].error = false
            this.formConfig[key].errorMessage = ''
          }
        }
      } else if (this.validator.errors.items.length > 0) {
        // If the validator contains errors
        const keysWithErrors = []
        const keysWithoutErrors = []

        // Loop through all the fields
        for (let key in this.formConfig) {
          let keyHasError = false
          let keyError = {}
          // Loop over all the errors
          this.validator.errors.items.forEach((error, index) => {
            // If the field has an error then assign that error to the field
            if (this.formConfig[key].ref === error.field) {
              keyHasError = true
              keyError = error
            }
            // If at the end of the loop then push it in the right array
            if (this.validator.errors.items.length - 1 === index) {
              if (keyHasError === true) {
                keysWithErrors.push({
                  key: key,
                  error: keyError
                })
              } else if (typeof this.formConfig[key].ref !== 'undefined') {
                keysWithoutErrors.push(key)
              }
            }
          })
        }
        // Keys without errors are set to no error
        keysWithoutErrors.forEach((key) => {
          this.formConfig[key].error = false
          this.formConfig[key].errorMessage = ''
        })
        // Keys with errors are set to there error message
        keysWithErrors.forEach((obj) => {
          this.formConfig[obj.key].error = true
          this.formConfig[obj.key].errorMessage = obj.error.msg
        })
        let errFirstField = this.validator.errors.items[0].field
        if (errFirstField && this.nextStepClicked) {
          document.querySelector('#' + errFirstField).focus()
        }
      }
    },
    checkRadioAnswer (value) {
      this.savePrescriberRegistrationDetails({
        key: 'titleId',
        value: value
      })
    },
    savePrescriberRegistrationDetails (prescriberRegistrationDetails) {
      store.commit('prescriberRegistration/setPrescriberRegistrationDetails', prescriberRegistrationDetails)
    }
  }
}
</script>

<style lang="scss" scoped>
 
.prescriberRegistrationStep2 {
  /deep/
  .form-group {
    padding: 0px;
    label {
      display: none;
    }
  }  
  &__stepTitle {
    margin: 15px 0px 30px 0px;
    font-size: 28px;
    color: $teal-darkest;
    text-align: center;
  }
  &__stepSubtitle {
    padding: 0 40px 0 40px;
  }
  &__block {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: $white;
    margin: 0 auto 30px auto;
    &__header {
      background-color: $grayish-very-light;
      font-size: 18px;
      color: $grayish-very-dark;
      padding: 20px;
    }
    &__content {
      padding-bottom: 30px;
      &__section {
        margin: 0 15px 15px 15px;
        span {
          float: left;
          margin: 12px 8px 0 0;
        }
        &__gender {
          display: inline-block;
          padding-right: 16px !important;
        }
      }
    }
  }
  &__actions {
    float: right;
    margin: 1% 25% 5% 0;
    &__previous {
      margin-right: 30px;
    }
  }
  &__successMessage {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    color: $dark-green;
    text-align: center;
    margin: 30px 0px 30px 0px;
    &__icon {
      fill: $dark-green !important;
      display: inline-block;
      margin: 0px 5px 0px 0px;
      vertical-align: middle;
      /deep/ svg {
        width: 40px;
        height: 40px;
      }
    }
  }
  .material-design-icon {
    fill: $teal-darkest;
  }
  /deep/
  .form-group__radio input[type=radio] + label {
    color: $gray-dark;
    font-size: 16px;
  }
}
</style>
